// eslint-disable-next-line
import { injectable } from "inversify";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import { ICustomizationClassic, IEdgeCustomization } from "../../models/User";
import {WithOld} from "../../stores/types";

@injectable()
class CustomizationsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async loadCustomisations(): Promise<ICustomizationClassic> {
        const res = await this.httpService.get<IApiResponse<ICustomizationClassic>>(`/rms-api/customization`);
        return res.payload;
    }

    public async updateCustomizations(data: WithOld<ICustomizationClassic>): Promise<ICustomizationClassic> {
        const res = await this.httpService.put<IApiResponse<ICustomizationClassic>>(`/rms-api/customization`, data);
        return res.payload;
    };

    public async loadEdgeCustomizations(): Promise<IEdgeCustomization> {
        const res = await this.httpService.get<IApiResponse<IEdgeCustomization>>(`/rms-api/edge-customization`);
        return res.payload;
    }

    public async updateEdgeCustomizations(data: WithOld<IEdgeCustomization>): Promise<IEdgeCustomization> {
        const res = await this.httpService.put<IApiResponse<IEdgeCustomization>>(`/rms-api/edge-customization`, data);
        return res.payload;
    };
}

export default CustomizationsService;
